export const appList = [
  {
    name: "进口贸易管理平台",
    icon: "shuzihuaguanli",
    desc: "订单、报关、物流、付汇",
    background: "#2da0f9"
  },
  {
    name: "出口贸易管理平台",
    icon: "shujukanban",
    desc: "出口贸易",
    background: "#2da0f9"
  },
  {
    name: "智慧风控平台",
    icon: "fengkongnengli",
    desc: "大数据、模板化、自动化",
    background: "#2da0f9"
  },
  {
    name: "代采代销管理系统",
    icon: "gongyinglian",
    desc: "代销、代采",
    background: "#2da0f9"
  },
  {
    name: "外贸综合服务平台",
    icon: "xinyong",
    desc: "进口、出口、报关",
    background: "#1ed0ac"
  },
  {
    name: "商贸云管家",
    icon: "maoyi",
    desc: "订单、集采、物流、进销存",
    background: "#1ed0ac"
  },
  {
    name: "转口业务管理平台",
    icon: "gongxuduijiexiao",
    desc: "跨国贸易一站通",
    background: "#1ed0ac"
  },
  {
    name: "数据大屏系统",
    icon: "zichan",
    desc: "自定义大屏、简单快捷、震撼漂亮",
    background: "#1ed0ac"
  },
  {
    name: "资方通",
    icon: "zijinguanli",
    desc: "数据化、结构化、精准化",
    background: "#fd6f6e"
  },
  {
    name: "数据中台",
    icon: "shujukanban",
    desc: "结构化、图形化、多维度",
    background: "#fd6f6e"
  },
  {
    name: "数字营销平台",
    icon: "crm",
    desc: "精管控、智分析、移动化",
    background: "#fd6f6e"
  },
  {
    name: "指标预警监测平台",
    icon: "shujukanban",
    desc: "风险指标、业务指标、财务指标",
    background: "#fd6f6e"
  }
];



// WEBPACK FOOTER //
// ./src/utils/optionData.js